import { NotifType } from '../../core/models/notif.model';
import { MovementState } from '../../core/models/movement/movement-state';
import { OperationState } from '../../core/models/operations/operation-state-enum';
import { OperationType } from '../../core/models/operations/operation-type-enum';

export class NotifsUtils {
  /**
   * Get notification url
   * @returns void
   */
  public static getUrl(redirectId: string, type: NotifType, misc: string): any {
    const searchUrl = '/private/search';
    const settingUrl = '/private/management';
    const managementUrl = '/private/management';
    const movementsUrl = '/private/management/movements';
    if (this.isCancelledRefusedExpired(type)) {
      return [searchUrl];
    } else if (this.isRedirectedToTrade(redirectId, type, misc)) {
      return [`/private/relocalisation/trades/${redirectId}`];
    } else {
      switch (type) {
        case NotifType.CREATE_STOCK:
          return [`${managementUrl}/stocks`];
        case NotifType.TICKET_ALMOST_EXPIRED:
          return [`${managementUrl}/tickets`];
        case NotifType.TICKET_EXPIRED:
          return ['/private/dashboard'];
        case NotifType.LOSS_RATE:
        case NotifType.THRESHOLD:
          return [managementUrl];
        case NotifType.TRADE_MATCH:
          return ['/private/search', { id: redirectId }];
        case NotifType.SET_UP_ACCOUNT:
          return [settingUrl];
        case NotifType.TRADE_FINALIZED:
          return [searchUrl];
        //case NotifType.INVOICE_CREATED:
        //  return ['/private/account/invoices'];
        case NotifType.PARTNERSHIP_STATE:
          return [`${settingUrl}/partners`];
        case NotifType.CREATE_PLACE:
          return [settingUrl];
        case NotifType.COLLABORATIVE_OPERATION_CREATED:
          return [
            movementsUrl,
            {
              operationType: OperationType.TO_PROCESS,
              movementState: `${MovementState.IN_PROGRESS}_${OperationState.TO_PROCESS}`
            }
          ];
        case NotifType.COLLABORATIVE_CONTEST_CREATED:
          return [movementsUrl, { movementId: redirectId }];
        case NotifType.COLLABORATIVE_CONTEST_REFUSED:
          return [movementsUrl, { movementId: redirectId }];
        default:
          break;
      }
    }
    return [];
  }

  public static isTrade(type: NotifType, misc: string): boolean {
    return type.startsWith('TRADE') || misc === 'TRADE';
  }

  public static isTradeContestation(type: NotifType): boolean {
    return [
      NotifType.TRADE_CONTEST_CREATED,
      NotifType.TRADE_CONTEST_ACCEPTED,
      NotifType.TRADE_CONTEST_REFUSED
    ].includes(type);
  }

  public static isSale(type: NotifType, misc: string) {
    return type.startsWith('SALE') || misc === 'SALE';
  }

  public static isMatch(type: NotifType) {
    return type === NotifType.TRADE_MATCH;
  }

  public static isFinalized(type: NotifType) {
    return type === NotifType.TRADE_FINALIZED;
  }

  public static isRedirectedToTrade(
    redirectId: string,
    type: NotifType,
    misc: string
  ) {
    return (
      redirectId &&
      (this.isTrade(type, misc) || this.isTradeContestation(type)) &&
      !this.isMatch(type) &&
      !this.isFinalized(type)
    );
  }

  public static isRedirectedToSale(
    redirectId: string,
    type: NotifType,
    misc: string
  ) {
    return redirectId && this.isSale(type, misc);
  }

  public static isCancelledRefusedExpired(type: NotifType): boolean {
    return [
      NotifType.TRADE_CANCELED,
      NotifType.SALE_CANCELED,
      NotifType.TRADE_REFUSED,
      NotifType.SALE_REFUSED,
      NotifType.TRADE_EXPIRED,
      NotifType.TRADE_EXPIRED_BY_COMPANY_TICKET,
      NotifType.TRADE_EXPIRED_BY_PARTNER_TICKET,
      NotifType.SALE_EXPIRED_BY_COMPANY_TICKET,
      NotifType.SALE_EXPIRED_BY_PARTNER_TICKET
    ].includes(type);
  }

}
